import React, { FunctionComponent as FC, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { State } from "../../../../state";
  import { bindActionCreators } from "redux";
  import { actionCreators } from "../../../../state";
  import "./index.scss";

  import { Spin, Slider, Switch, Form, ConfigProvider, Select, Input, Button } from "antd";
  import {
    SearchOutlined,
  } from '@ant-design/icons';
  import _ from "lodash";

  import Panel from "../../common/Panel";
  import SubTitle from "../../common/SubTitle";
  import { GlobalStyle } from "../../../../types/style.d";
  import { funderOrganizationHierarchy, countryFunderHierarchy, caseType, queryViewData, CitationFlowType, ImpactType } from "../../../../types/data.global";
  import { QueryViewTypes } from "../../../../types/data";

  interface QueryViewProps {
    viewParam: GlobalStyle.ViewSize;
    panelParam: GlobalStyle.PanelStyle;
    viewName: string;
  }

  const QueryView: FC<QueryViewProps> = (props) => {
    const { viewParam, panelParam, viewName } = props;

    const { Search } = Input;

    const dispatch = useDispatch()
    const {
      getGrantIdList,
      setQueryViewFolded,

      // clear all state variables when click confirm button
      clearMainViewData,
      updateCitationFlowType,
      updateImpactType,
      updateImpactStatisticsTypeList,
      setShowEntityFieldLevelGraph,
      setShowEntityTypeLevelGraph,
      // updateIsEntityFieldGraphFinished,
      updateIsInitializeBubbleTreemapFinished,
      updateIsOptimizedBubbleTreemapFinished,
      updateIsEntityTypeGraphFinished,
      cleanMainviewGraph,
      clearCheckboxSelection,
      updateSelectedImpactEntityField,
      onClickGrantFieldNode,
      onClickImpactFieldNode,
      updateHighlghtedGrantFieldID,
      isShowLeafNode,
      isShowPredictionFlow,
      isShowHistoricalFlow,
      isShowHistoricalGraph,
      isShowPredictionGraph,

      updateEntityTypeLayoutData,
      updateLeafNodeSizeScale,
      updateLeafNodeInitialPositionList,
      updateBubbleTreemapEntityGroupList,
      updateBubbleTreemapGeometryGroup,
      updateWordlePosition,
      updateWordleEntity,
      isShowWordle,
      updatePredictionSearchResult,
      updatePredictionGrantIDList4PIView,
      updateLeafNodePositionList,
      updateEntityFieldGraph_InputData,
      updateGrantFieldNodePosition,
      updateNodePositionList,
    } = bindActionCreators(actionCreators, dispatch)

    // ui reducer
    const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string

    const emptyFundingAgency = {
      funderGridID: '',
      funderName: '',
    };

    // 1. styles
    const [isFolded, setIsFolded] = useState<boolean>(false)

    const [startYear, setStartYear] = useState<number[]>([2000, 2021])
    const [endYear, setEndYear] = useState<number[]>([2000, 2030])
    const [fundingUSD, setFundingUSD] = useState<number[]>([0, 4000000000])
    const [country, setCountry] = useState<string>('United States');

    const [case2Country, setCase2Country] = useState<QueryViewTypes.CountryFunderHierarchy>();
    const [fundingAgencies, setFundingAgencies] = useState<QueryViewTypes.CountryFunderHierarchyUnit[]>([]);
    const [selectedCase2FundingAgency, setSelectedCase2FundingAgency] = useState<QueryViewTypes.CountryFunderHierarchyUnit>();
    const [selectedFundingAgency, setSelectedFundingAgency] = useState<QueryViewTypes.FunderOrganizationHierarchy>(funderOrganizationHierarchy[0]);
    const [subInstitutes, setSubInstitutes] = useState<QueryViewTypes.FunderOrganizationHierarchyUnit[]>(funderOrganizationHierarchy[0].childrenList);
    const [selectedSubInstitute, setSelectedSubInstitute] = useState<QueryViewTypes.FunderOrganizationHierarchyUnit>(funderOrganizationHierarchy[0].childrenList[0]);

    const [keywordSearch, setKeywordSearch] = useState<string>('');

    // opt 1: if-else for case 1 and case 2

    if(caseType === "case1"){
    // ===== caseType: "case1" =====
    // 1. useState: update filtering parameters
    const toggleFold = () => {
      setIsFolded(!isFolded)
    }

    const onStartTimeChangeComplete = (value: number | number[]) => {
      console.log('onStartTimeChangeComplete: ', value);
      setStartYear(value as number[]);
    };

    const onEndTimeChangeComplete = (value: number | number[]) => {
      console.log('onEndTimeChangeComplete: ', value);
      setEndYear(value as number[]);
    };

    const onFundingUSDChangeComplete = (value: number | number[]) => {
      console.log('onFundingUSDChangeComplete: ', value);
      setFundingUSD(value as number[]);
    };

    const handleCountryChange = (value: string) => {
      console.log(`handleCountryChange selected ${value}`);
      setCountry(value);
    };

    const handleFundingAgencyChange = (value: string) => {
      console.log(`handleFundingAgencyChange selected ${value}`);
      const selectedFundingAgency = queryViewData.funderOrganizationHierarchy.find(funder => funder.self.funderGridID === value);
      setSelectedFundingAgency(selectedFundingAgency ? selectedFundingAgency : funderOrganizationHierarchy[0]);
      setSubInstitutes(selectedFundingAgency ? selectedFundingAgency.childrenList : []);
      setSelectedSubInstitute(undefined as unknown as QueryViewTypes.FunderOrganizationHierarchyUnit);
    };

    const handleSubInstituteChange = (value: string) => {
      console.log(`handleSubInstituteChange selected ${value}`);
      const selectedSubInstitute = subInstitutes.find(institutes => institutes.funderGridID === value);
      setSelectedSubInstitute(selectedSubInstitute ? selectedSubInstitute : funderOrganizationHierarchy[0].childrenList[0]);
    };

    const handleKeywordSearchChange = (value: string) => {
      console.log(`handleKeywordSearchChange: ${value}`);
      setKeywordSearch(value);
    };

    // 2. handleConfirmButton: call backend to update all views
    const handleConfirmButton = () => {
      console.log('Query View: confirm button clicked!');
      var params = {
        startYear: startYear,
        endYear: endYear,
        fundingUSD: fundingUSD,
        country: country,
        fundingAgency: selectedFundingAgency? selectedFundingAgency.self : emptyFundingAgency,
        subInstitute: selectedSubInstitute? [selectedSubInstitute] : (selectedFundingAgency? selectedFundingAgency.childrenList : []),
        keyword: keywordSearch,
      }
      console.log('params: ', params)

      // 创建 Promise 确保步骤1先完成
      Promise.resolve()
      .then(() => {
        // 步骤1：清理所有变量和重置到初始状态
        // 1. clear all variables and reset to initial state
        // copy from component <Panel> > `handleChangeImapctTypeDropdown()`
        // ===== copy start =====
        // clear everything then start over again

        // console.log(`selected ${value}`);

        // newly added for this handleConfirmButton(): clean mainview data
        // no need to add this for other two cases: <Panel> > `handleChangeImapctTypeDropdown()`, 右上角view > confirm button  -- 因为不需要去后端重新计算
        clearMainViewData();

        // clear ui reducer: mainview graph
        setShowEntityTypeLevelGraph(false);
        setShowEntityFieldLevelGraph(false);
        updateIsEntityTypeGraphFinished(false);
        isShowHistoricalGraph(true);
        isShowPredictionGraph(false);
        updateHighlghtedGrantFieldID('all');
        isShowLeafNode(true);
        // updateIsEntityFieldGraphFinished(false);
        updateIsInitializeBubbleTreemapFinished(false);
        updateIsOptimizedBubbleTreemapFinished(false);
        cleanMainviewGraph(true);
        isShowWordle(false);
        isShowPredictionFlow(false);
        isShowHistoricalFlow(false);
        updateCitationFlowType(CitationFlowType.HISTORICAL);

        // clear checkbox selection
        updateImpactStatisticsTypeList(['patent', 'clinical_trial', 'policy']); // set to initial state in store
        updateImpactType(ImpactType.INDIRECT_IMPACT_FOLDED); // set to initial state in store

        // clear data reducer: all data stored in redux about mainview calc should be cleared
        updateEntityTypeLayoutData([]);
        updateLeafNodeSizeScale(0, '');
        // store leaf node positions to state - for drawing edges
        updateLeafNodeInitialPositionList({
          leafNodePositionList: [],
          bubbleTreemapEntityTypeCenterXYList: [],
        });
        updateBubbleTreemapEntityGroupList([]);
        updateBubbleTreemapGeometryGroup([]);
        updateWordlePosition({
          left: 0,
          top: 0,
        });
        updateWordleEntity({
          entity: '',
          fieldID: '',
        });
        updateSelectedImpactEntityField({});
        updatePredictionSearchResult({
          entity: '',
          fieldIDList: [],
        });
        updatePredictionGrantIDList4PIView([], []);
        // clear up historical selected (1) citation flow (2) highlight node
        onClickGrantFieldNode({
          grantFieldID: '',
          grantFieldName: '',
          impactType: impactType,
        })
        // clear highlighted impact field node
        onClickImpactFieldNode({
          impactType: '',
          impactEntity: '',
          impactFieldID: '',
        })

        // component: OptimizedBubbleTreemap
        updateLeafNodePositionList({
          leafNodePositionList: [],
          bubbleTreemapEntityTypeCenterXYList: [],
        });
        updateEntityFieldGraph_InputData([]);

        // component: GrantTypeNode
        updateGrantFieldNodePosition({
          grantNodePositionList: [],
          isDrawGrantTypeNodeFinished: false,
        })

        // component: EntityFieldLevelCitationFlow
        updateNodePositionList([]);


        // clear all selection of checkbox
        clearCheckboxSelection(true)
        // ===== copy end =====
      })
      .then(() => {
        // 步骤2：调用后端API更新所有视图
        // 2. call backend API to update all views
        const updateAllViews = async () => {
          try {
            console.log('Query View: start updateAllViews...');

            // update UI: fold Query View
            setQueryViewFolded(true)

            // call backend API to update all views
            const result = await getGrantIdList(params)
          } catch (error) {
            console.error(error);
          } finally {
            console.log('Query View: updateAllViews finished!');

            // set cleanMainviewGraph to false, to enable default mainview graph
            cleanMainviewGraph(false)
          }
        }
        updateAllViews();
      })
      .catch((error) => {
        console.error('Error in handleConfirmButton:', error);
      });
    }

    return (
      <Panel
        viewTitle={viewName}
        width={viewParam.width}
        height={viewParam.height}
        margin={panelParam.margin}
        padding={panelParam.padding}
        panelHeaderHeight={panelParam.panelHeaderHeight}
      >
        <ConfigProvider
          theme={{
            token:{
              colorPrimary: '#7F5539',
            },
            // components: {
            //   Form: {
            //     labelFontSize: 13,
            //     itemMarginBottom: 6,
            //   },
            //   Slider: {
            //     // Customize slider text/tooltip font size
            //     fontSize: 12, // This controls the overall font size for slider
            //     controlSize: 8,
            //     dotSize: 6,
            //   },
            //   Tooltip: {
            //     // This controls tooltip font size (including slider tooltips)
            //     fontSize: 12,
            //   },
            // }
          }}
        >
            <div className="query-view" >
              <div className="grant-part">
                <SubTitle title="Grant" />
                <div className="grant-part-content">
                    <Form
                      size="middle"
                      labelAlign="left"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 15 }}
                      layout="horizontal"
                      // style={{ maxWidth: 300 }}
                    >
                      <Form.Item label="Start Year">
                        <Slider
                            range
                            defaultValue={startYear}
                            min = {queryViewData.startYearRange[0]}
                            max = {queryViewData.startYearRange[1]}
                            style={{ marginLeft: 16 }}
                            // style={{ marginLeft: 16, width: "180px" }}
                            onChangeComplete={onStartTimeChangeComplete}
                          />
                      </Form.Item>
                      {/* <Form.Item label="End Year">
                        <Slider
                            range
                            defaultValue={endYear}
                            min = {queryViewData.endYearRange[0]}
                            max = {queryViewData.endYearRange[1]}
                            style={{ marginLeft: 16 }}
                            // style={{ marginLeft: 16, width: "180px" }}
                            onChangeComplete={onEndTimeChangeComplete}
                          />
                      </Form.Item> */}
                      <Form.Item label="Funding USD">
                        <Slider
                            range
                            defaultValue={fundingUSD}
                            min = {queryViewData.fundingUSDRange[0]}
                            max = {queryViewData.fundingUSDRange[1]}
                            style={{ marginLeft: 16 }}
                            // style={{ marginLeft: 16, width: "180px" }}
                            onChangeComplete={onFundingUSDChangeComplete}
                          />
                      </Form.Item>
                    </Form>
                </div>
              </div>
              <div className="funding-agency-part">
                <SubTitle title="Funding Agency" />
                  <div className="funding-agency-part-content">
                      <Form
                        size="middle"
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 15 }}
                        layout="horizontal"
                        // style={{ maxWidth: 300 }}
                      >
                        <Form.Item label="Country">
                          <Select
                            value={country}
                            size="small"
                            // style={{ width: 180, height: 28 }}
                            onChange={handleCountryChange}
                            defaultValue="United States"
                            options={queryViewData.countryList.map(country => {
                              return {
                                value: country,
                                label: country,
                              }
                            })}
                          />
                        </Form.Item>
                        <Form.Item label="Agency">
                          <Select
                            value={selectedFundingAgency? selectedFundingAgency.self.funderName : "--"}
                            size="small"
                            // style={{ width: 180, height: 28 }}
                            onChange={handleFundingAgencyChange}
                            options={
                              funderOrganizationHierarchy.map(funder => {
                                return {
                                  value: funder.self.funderGridID,
                                  label: funder.self.funderName,
                                }
                              }
                            )}
                          />
                        </Form.Item>
                        <Form.Item label="Sub-agency">
                          <Select
                            value={selectedSubInstitute? selectedSubInstitute.funderName : "--"}
                            size="small"
                            // style={{ width: 205, height: 28 }}
                            onChange={handleSubInstituteChange}
                            options={
                              subInstitutes.map(subInstitute => {
                                return {
                                  value: subInstitute.funderGridID,
                                  label: subInstitute.funderName,
                                }
                              }
                            )}
                          />
                        </Form.Item>
                      </Form>
                  </div>
              </div>
              {/* <div className="research-field-part">
                  <SubTitle title="Research Field" />
                  <div className="research-field-part-content">
                      <Form
                        size="middle"
                        labelAlign="left"
                        labelCol={{ span: 9 }}
                        wrapperCol={{ span: 15 }}
                        layout="horizontal"
                        style={{ maxWidth: 300 }}
                      >
                        <Form.Item label="Keyword">
                          <Search
                            placeholder="Search Keywords"
                            allowClear
                            onSearch={handleKeywordSearchChange}
                            style={{ width: 205, height: 28 }}
                          />
                        </Form.Item>
                      </Form>
                  </div>
              </div> */}
              <div className="comfirm-button">
                <Button icon={<SearchOutlined />} onClick={handleConfirmButton}>Query</Button>
              </div>
            </div>
          </ConfigProvider>
      </Panel>
    );
    } else{
      // case2
        const toggleFold = () => {
          setIsFolded(!isFolded)
      }

      const onStartTimeChangeComplete = (value: number | number[]) => {
        console.log('onStartTimeChangeComplete: ', value);
        setStartYear(value as number[]);
      };

      const onEndTimeChangeComplete = (value: number | number[]) => {
        console.log('onEndTimeChangeComplete: ', value);
        setEndYear(value as number[]);
      };

      const onFundingUSDChangeComplete = (value: number | number[]) => {
        console.log('onFundingUSDChangeComplete: ', value);
        setFundingUSD(value as number[]);
      };

      const handleCountryChange = (value: string) => {
        console.log(`handleCountryChange selected ${value}`);
        const selectedCountry = countryFunderHierarchy.find(country => country.country === value);
        setCase2Country(selectedCountry ? selectedCountry : undefined);
        setFundingAgencies(selectedCountry ? selectedCountry.gridList : []);
        setSelectedCase2FundingAgency(undefined);
      };

      const handleFundingAgencyChange = (value: string) => {
        console.log(`handleFundingAgencyChange selected ${value}`);
        const selectedFundingAgency = fundingAgencies.find(funder => funder.funderGridID === value);
        console.log(`selectedFundingAgency: ${selectedFundingAgency?.funderName}`)
        setSelectedCase2FundingAgency(selectedFundingAgency ? selectedFundingAgency : undefined);
        // setSubInstitutes(selectedFundingAgency ? selectedFundingAgency.childrenList : []);
        // setSelectedSubInstitute(undefined);
      };

      const handleSubInstituteChange = (value: string) => {
        console.log(`handleSubInstituteChange selected ${value}`);
        // const selectedSubInstitute = subInstitutes.find(institutes => institutes.funderGridID === value);
        // setSelectedSubInstitute(selectedSubInstitute);
      };

      const handleKeywordSearchChange = (value: string) => {
        console.log(`handleKeywordSearchChange: ${value}`);
        setKeywordSearch(value);
      };

      const handleConfirmButton = () => {
        console.log('Confirm button clicked');
        var params = {
          startYear: startYear,
          endYear: endYear,
          fundingUSD: fundingUSD,
          country: case2Country ? case2Country.country : '',
          // country: country,
          fundingAgency: selectedCase2FundingAgency? selectedCase2FundingAgency : emptyFundingAgency,
          subInstitute: [],
          keyword: keywordSearch,
        }
        console.log('Query View updateAllViews params: ', params);
        // const result = getInitialGrantData(params)
        const updateAllViews = async () => {
          try {
            // console.log("Query View updateAllViews start")
            // updateGrantViewLoading(true)
            // updatePIViewLoading(true)
            // updateImpactEntityViewLoading(true)
            // updateImpactStatisticsViewLoading(true)
            // // updatePIViewLoading(true)

            // update UI: fold Query View
            setQueryViewFolded(true)

            const result = await getGrantIdList(params)
            // const result = await getInitialGrantData(params)
          } catch (error) {
            console.error(error);
          } finally {
            // console.log('Query View updateAllViews finished');
          }
        }
        updateAllViews()
      }

        // const handleMetricChange = (value: string) => {
        //   console.log(`handleMetricChange selected: ${value}`);
        // };

        return (
          <Panel
            viewTitle={viewName}
            width={viewParam.width}
            height={viewParam.height}
            panelHeaderHeight={panelParam.panelHeaderHeight}
            margin={panelParam.margin}
            padding={panelParam.padding}
          >
            {/* <Spin tip="Loading" spinning={isTechnologyInspectionViewLoading} size='large'> */}
            <ConfigProvider
              theme={{
                token:{
                  colorPrimary: '#7F5539',
                },
                components: {
                  Form: {
                    labelFontSize: 16,
                    itemMarginBottom: 6,
                  },
                }
              }}
            >
                <div className="query-view" >
                  <div className="grant-part">
                    <SubTitle title="Grant" />
                    <div className="grant-part-content">
                        <Form
                          size="middle"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          layout="horizontal"
                          style={{ maxWidth: 300 }}
                        >
                          <Form.Item label="Start Year">
                            <Slider
                                range
                                defaultValue={startYear}
                                min = {2000}
                                max = {2021}
                                style={{ marginLeft: 16, width: "180px" }}
                                onChangeComplete={onStartTimeChangeComplete}
                              />
                          </Form.Item>
                          <Form.Item label="End Year">
                            <Slider
                                range
                                defaultValue={endYear}
                                min = {2000}
                                max = {2030}
                                style={{ marginLeft: 16, width: "180px" }}
                                onChangeComplete={onEndTimeChangeComplete}
                              />
                          </Form.Item>
                          <Form.Item label="Funding USD">
                            <Slider
                                range
                                defaultValue={fundingUSD}
                                min = {0}
                                max = {4000000000}
                                style={{ marginLeft: 16, width: "180px" }}
                                onChangeComplete={onFundingUSDChangeComplete}
                              />
                          </Form.Item>
                        </Form>
                    </div>
                  </div>
                  <div className="funding-agency-part">
                    <SubTitle title="Funding Agency" />
                      <div className="funding-agency-part-content">
                          <Form
                            size="middle"
                            labelAlign="left"
                            labelCol={{ span: 11 }}
                            wrapperCol={{ span: 12 }}
                            layout="horizontal"
                            style={{ maxWidth: 300 }}
                          >
                            <Form.Item label="Country">
                              <Select
                                value={case2Country? case2Country.country : "--"}
                                style={{ width: 180, height: 28 }}
                                onChange={handleCountryChange}
                                options={
                                  countryFunderHierarchy.map(entry => {
                                    return {
                                      value: entry.country,
                                      label: entry.country,
                                    }
                                  })
                                }
                              />
                            </Form.Item>
                            <Form.Item label="Funding Agency">
                              <Select
                                value={selectedCase2FundingAgency? selectedCase2FundingAgency.funderName : "--"}
                                style={{ width: 180, height: 28 }}
                                onChange={handleFundingAgencyChange}
                                options={
                                  fundingAgencies.map(funder => {
                                    return {
                                      value: funder.funderGridID,
                                      label: funder.funderName,
                                    }
                                  }
                                )}
                              />
                            </Form.Item>
                            <Form.Item label="Sub-institute" labelCol={{ span: 9 }} wrapperCol={{ span: 15 }}>
                              <Select
                                value={"--"}
                                style={{ width: 205, height: 28 }}
                                onChange={handleSubInstituteChange}
                                options={[]}
                              />
                            </Form.Item>
                          </Form>
                      </div>
                  </div>
                  <div className="research-field-part">
                    <SubTitle title="Research Field" />
                      <div className="research-field-part-content">
                          <Form
                            size="middle"
                            labelAlign="left"
                            labelCol={{ span: 9 }}
                            wrapperCol={{ span: 15 }}
                            layout="horizontal"
                            style={{ maxWidth: 300 }}
                          >
                            <Form.Item label="Keyword">
                              <Search
                                placeholder="Search Keywords"
                                allowClear
                                onSearch={handleKeywordSearchChange}
                                style={{ width: 205, height: 28 }}
                              />
                            </Form.Item>
                          </Form>
                      </div>
                    </div>
                  <div className="comfirm-button">
                    <Button icon={<SearchOutlined />} onClick={handleConfirmButton}>Query</Button>
                  </div>
                </div>
              </ConfigProvider>
            {/* </Spin> */}
          </Panel>
        );
    }




    // // opt 2: only for case 1, no if-else
    // // ===== caseType: "case1" =====
    // // 1. useState: update filtering parameters
    // const toggleFold = () => {
    //   setIsFolded(!isFolded)
    // }

    // const onStartTimeChangeComplete = (value: number | number[]) => {
    //   console.log('onStartTimeChangeComplete: ', value);
    //   setStartYear(value as number[]);
    // };

    // const onEndTimeChangeComplete = (value: number | number[]) => {
    //   console.log('onEndTimeChangeComplete: ', value);
    //   setEndYear(value as number[]);
    // };

    // const onFundingUSDChangeComplete = (value: number | number[]) => {
    //   console.log('onFundingUSDChangeComplete: ', value);
    //   setFundingUSD(value as number[]);
    // };

    // const handleCountryChange = (value: string) => {
    //   console.log(`handleCountryChange selected ${value}`);
    //   setCountry(value);
    // };

    // const handleFundingAgencyChange = (value: string) => {
    //   console.log(`handleFundingAgencyChange selected ${value}`);
    //   const selectedFundingAgency = queryViewData.funderOrganizationHierarchy.find(funder => funder.self.funderGridID === value);
    //   setSelectedFundingAgency(selectedFundingAgency ? selectedFundingAgency : undefined);
    //   setSubInstitutes(selectedFundingAgency ? selectedFundingAgency.childrenList : []);
    //   setSelectedSubInstitute(undefined);
    // };

    // const handleSubInstituteChange = (value: string) => {
    //   console.log(`handleSubInstituteChange selected ${value}`);
    //   const selectedSubInstitute = subInstitutes.find(institutes => institutes.funderGridID === value);
    //   setSelectedSubInstitute(selectedSubInstitute);
    // };

    // const handleKeywordSearchChange = (value: string) => {
    //   console.log(`handleKeywordSearchChange: ${value}`);
    //   setKeywordSearch(value);
    // };

    // // 2. handleConfirmButton: call backend to update all views
    // const handleConfirmButton = () => {
    //   console.log('Query View: confirm button clicked!');
    //   var params = {
    //     startYear: startYear,
    //     endYear: endYear,
    //     fundingUSD: fundingUSD,
    //     country: country,
    //     fundingAgency: selectedFundingAgency? selectedFundingAgency.self : emptyFundingAgency,
    //     subInstitute: selectedSubInstitute? [selectedSubInstitute] : (selectedFundingAgency? selectedFundingAgency.childrenList : []),
    //     keyword: keywordSearch,
    //   }
    //   const updateAllViews = async () => {
    //     try {
    //       console.log('Query View: start updateAllViews...');

    //       // update UI: fold Query View
    //       setQueryViewFolded(true)

    //       // call backend API to update all views
    //       const result = await getGrantIdList(params)
    //     } catch (error) {
    //       console.error(error);
    //     } finally {
    //       console.log('Query View: updateAllViews finished!');
    //     }
    //   }
    //   updateAllViews()
    // }

    // return (
    //   <Panel
    //     viewTitle={viewName}
    //     width={viewParam.width}
    //     height={viewParam.height}
    //     margin={panelParam.margin}
    //     padding={panelParam.padding}
    //     panelHeaderHeight={panelParam.panelHeaderHeight}
    //   >
    //     <ConfigProvider
    //       theme={{
    //         token:{
    //           colorPrimary: '#7F5539',
    //         },
    //         // components: {
    //         //   Form: {
    //         //     labelFontSize: 13,
    //         //     itemMarginBottom: 6,
    //         //   },
    //         //   Slider: {
    //         //     // Customize slider text/tooltip font size
    //         //     fontSize: 12, // This controls the overall font size for slider
    //         //     controlSize: 8,
    //         //     dotSize: 6,
    //         //   },
    //         //   Tooltip: {
    //         //     // This controls tooltip font size (including slider tooltips)
    //         //     fontSize: 12,
    //         //   },
    //         // }
    //       }}
    //     >
    //         <div className="query-view" >
    //           <div className="grant-part">
    //             <SubTitle title="Grant" />
    //             <div className="grant-part-content">
    //                 <Form
    //                   size="middle"
    //                   labelAlign="left"
    //                   labelCol={{ span: 8 }}
    //                   wrapperCol={{ span: 15 }}
    //                   layout="horizontal"
    //                   style={{ maxWidth: 300 }}
    //                 >
    //                   <Form.Item label="Start Year">
    //                     <Slider
    //                         range
    //                         defaultValue={startYear}
    //                         min = {queryViewData.startYearRange[0]}
    //                         max = {queryViewData.startYearRange[1]}
    //                         style={{ marginLeft: 16 }}
    //                         // style={{ marginLeft: 16, width: "180px" }}
    //                         onChangeComplete={onStartTimeChangeComplete}
    //                       />
    //                   </Form.Item>
    //                   {/* <Form.Item label="End Year">
    //                     <Slider
    //                         range
    //                         defaultValue={endYear}
    //                         min = {queryViewData.endYearRange[0]}
    //                         max = {queryViewData.endYearRange[1]}
    //                         style={{ marginLeft: 16 }}
    //                         // style={{ marginLeft: 16, width: "180px" }}
    //                         onChangeComplete={onEndTimeChangeComplete}
    //                       />
    //                   </Form.Item> */}
    //                   <Form.Item label="Funding USD">
    //                     <Slider
    //                         range
    //                         defaultValue={fundingUSD}
    //                         min = {queryViewData.fundingUSDRange[0]}
    //                         max = {queryViewData.fundingUSDRange[1]}
    //                         style={{ marginLeft: 16 }}
    //                         // style={{ marginLeft: 16, width: "180px" }}
    //                         onChangeComplete={onFundingUSDChangeComplete}
    //                       />
    //                   </Form.Item>
    //                 </Form>
    //             </div>
    //           </div>
    //           <div className="funding-agency-part">
    //             <SubTitle title="Funding Agency" />
    //               <div className="funding-agency-part-content">
    //                   <Form
    //                     size="middle"
    //                     labelAlign="left"
    //                     labelCol={{ span: 11 }}
    //                     wrapperCol={{ span: 12 }}
    //                     layout="horizontal"
    //                     style={{ maxWidth: 300 }}
    //                   >
    //                     <Form.Item label="Country">
    //                       <Select
    //                         value={country}
    //                         size="small"
    //                         // style={{ width: 180, height: 28 }}
    //                         onChange={handleCountryChange}
    //                         options={queryViewData.countryList.map(country => {
    //                           return {
    //                             value: country,
    //                             label: country,
    //                           }
    //                         })}
    //                       />
    //                     </Form.Item>
    //                     <Form.Item label="Funding Agency">
    //                       <Select
    //                         value={selectedFundingAgency? selectedFundingAgency.self.funderName : "--"}
    //                         size="small"
    //                         // style={{ width: 180, height: 28 }}
    //                         onChange={handleFundingAgencyChange}
    //                         options={
    //                           funderOrganizationHierarchy.map(funder => {
    //                             return {
    //                               value: funder.self.funderGridID,
    //                               label: funder.self.funderName,
    //                             }
    //                           }
    //                         )}
    //                       />
    //                     </Form.Item>
    //                     <Form.Item label="Sub-institute">
    //                       <Select
    //                         value={selectedSubInstitute? selectedSubInstitute.funderName : "--"}
    //                         size="small"
    //                         // style={{ width: 205, height: 28 }}
    //                         onChange={handleSubInstituteChange}
    //                         options={
    //                           subInstitutes.map(subInstitute => {
    //                             return {
    //                               value: subInstitute.funderGridID,
    //                               label: subInstitute.funderName,
    //                             }
    //                           }
    //                         )}
    //                       />
    //                     </Form.Item>
    //                   </Form>
    //               </div>
    //           </div>
    //           {/* <div className="research-field-part">
    //               <SubTitle title="Research Field" />
    //               <div className="research-field-part-content">
    //                   <Form
    //                     size="middle"
    //                     labelAlign="left"
    //                     labelCol={{ span: 9 }}
    //                     wrapperCol={{ span: 15 }}
    //                     layout="horizontal"
    //                     style={{ maxWidth: 300 }}
    //                   >
    //                     <Form.Item label="Keyword">
    //                       <Search
    //                         placeholder="Search Keywords"
    //                         allowClear
    //                         onSearch={handleKeywordSearchChange}
    //                         style={{ width: 205, height: 28 }}
    //                       />
    //                     </Form.Item>
    //                   </Form>
    //               </div>
    //           </div> */}
    //           <div className="comfirm-button">
    //             <Button icon={<SearchOutlined />} onClick={handleConfirmButton}>Query</Button>
    //           </div>
    //         </div>
    //       </ConfigProvider>
    //   </Panel>
    // );
  };

  export default QueryView;
